import { inject, Injectable, Pipe, PipeTransform } from '@angular/core';

import { TranslationService } from 'app/core/internationalization/translation.service';
import { LocalizationService } from 'app/core/localization/localization.service';
import { DateService } from 'app/shared/services/date.service';

@Injectable({
  providedIn: 'root'
})
@Pipe({
  name: 'khLocalizedDate',
  standalone: false
})
export class KhLocalizedDatePipe implements PipeTransform {
  private readonly dateService = inject(DateService);

  private readonly defaultLocaleId: string;

  public constructor() {
    const translationService = inject(TranslationService);
    const localizationService = inject(LocalizationService);

    this.defaultLocaleId = translationService.getCurrentLanguage() ?? localizationService.defaultLocaleId;
  }

  public transform(inputDate: Date | string, format = '', locale?: string): string {
    const LocaleId = locale ?? this.defaultLocaleId;
    return this.dateService.localeDate(new Date(inputDate), format, LocaleId);
  }
}
